import type { LucideIcon } from "lucide-react";
import { CalendarClock, Mail } from "lucide-react";

export const LANDING_FEATURED_CHECK = {
  iconKey: "PRIVACY_POLICY_FOUND",
  title: "Анализ политики обработки персональных данных",
  description:
    "Проверка текста политики обработки персональных данных на соответствие законодательству",
};

export interface LandingExtraFeature {
  id: string;
  title: string;
  description: string;
  icon: LucideIcon;
}

export const LANDING_EXTRA_FEATURES: LandingExtraFeature[] = [
  {
    id: "email-notifications",
    title: "Уведомления на почту",
    description:
      "Получайте регулярные отчёты о состоянии сайта и проверках на почту.",
    icon: Mail,
  },
  {
    id: "scheduled-monitoring",
    title: "Регулярный мониторинг",
    description:
      "Поставьте сайт на расписание — проверки будут выполняться автоматически по выбранному графику.",
    icon: CalendarClock,
  },
];
